import React from "react";
import { createDrawerNavigator } from "@react-navigation/drawer";
import HomeScreen from "../screens/Home/HomeScreen";
import ProfileScreen from "../screens/Profile/ProfileScreen";
import CustomDrawerContent from "../components/CustomDrawer";
import RequestEntryApprovalScreen from "../screens/Request/RequestEntryApprovalScreen";
import ReportScreen from "../screens/TimeTracking/ReportScreen";

const Drawer = createDrawerNavigator();

const SideTabs = () => {
  return (
    <Drawer.Navigator
      drawerContent={(props) => <CustomDrawerContent {...props} />}
      screenOptions={{
        drawerType: "permanent",
        drawerStyle: {
          width: 150,
        },
        headerShown: false, // We will set headers individually
      }}
    >
      <Drawer.Screen name="Home" component={HomeScreen} />
      <Drawer.Screen name="Report" component={ReportScreen} />
      <Drawer.Screen name="Request" component={RequestEntryApprovalScreen} />
      <Drawer.Screen name="Perfil" component={ProfileScreen} />
    </Drawer.Navigator>

  );
};

export default SideTabs;
